import { render } from "./view-stock-transfer.vue?vue&type=template&id=36719b49&scoped=true"
import script from "./view-stock-transfer.vue?vue&type=script&lang=js"
export * from "./view-stock-transfer.vue?vue&type=script&lang=js"

import "./view-stock-transfer.vue?vue&type=style&index=0&id=36719b49&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36719b49"]])

export default __exports__